import { useEffect, useRef, useState } from "react";
import MemberImage from "./ImageManager";

const LazyMemberImage = ({
  foodItemId,
  currentlySelling,
  imageUpdatedTimeFromDB,
  photoUploaded,
}) => {
  const ref = useRef();
  const hasLoadedRef = useRef(false);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting && !hasLoadedRef.current) {
          setIsVisible(true);
          hasLoadedRef.current = true; // Mark this member as loaded
          observer.disconnect(); // stop observing
        }
      },
      {
        threshold: 0.5,
      }
    );

    if (ref.current) {
      observer.observe(ref.current);
    }

    return () => observer.disconnect();
  }, []);

  return (
    <div ref={ref}>
      {isVisible ? (
        <MemberImage
          foodItemId={foodItemId}
          imageUpdatedTimeFromDB={imageUpdatedTimeFromDB}
          currentlySelling={currentlySelling}
          photoUploaded={photoUploaded}
        />
      ) : (
        <div />
      )}
    </div>
  );
};

export default LazyMemberImage;
